import { UPDATE_ORGANISATIONS } from '../actions';

export default function organisations(state = [], action) {
  switch (action.type) {
    case UPDATE_ORGANISATIONS:
      return action.organisations ? action.organisations : state;

    case 'LOGOUT':
      return [];

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/organisations.js